import { render, staticRenderFns } from "./AfterworkPage.vue?vue&type=template&id=280090e8&scoped=true&"
import script from "./AfterworkPage.vue?vue&type=script&lang=js&"
export * from "./AfterworkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280090e8",
  null
  
)

export default component.exports